import React from 'react';
import Select from '../Select';
import { connect } from 'react-redux';
import { Translate, translate } from 'react-i18nify';
import DropdownIndicator from '../DropdownIndicator';
import LoaderButton from '../LoaderButton';
import './SaveableMultiSelect.scss';

const SaveableMultiSelect = ({
  name,
  placeholderI18nKey,
  defaultValue,
  currentValue,
  noOptionsI18nKey,
  onChange,
  onSave,
  options,
  isSaving,
  actionI18nKey,
  requiredAuthority,
  authorities,
  fallbackKey
}) => {
  const wrappedOnChange = (value, event) => {
    onChange(value, event);
  };

  const savable = () => {
    return (
      (defaultValue && defaultValue.length !== currentValue.length) ||
      !defaultValue.map((val) => val.value).every((val) => currentValue.includes(val))
    );
  };

  if (requiredAuthority && authorities.indexOf(requiredAuthority) === -1) {
    if (currentValue.length) {
      if (fallbackKey) {
        return options
          .filter((option) => currentValue.includes(option.value))
          .map((option) => option[fallbackKey])
          .join(', ');
      }
      return currentValue.join(', ');
    }

    return '-';
  }

  return (
    <div className="saveable-multi-select">
      <Select
        isMulti
        name={name}
        placeholder={translate(placeholderI18nKey)}
        defaultValue={defaultValue}
        noOptionsMessage={() => <span>{translate(noOptionsI18nKey)}</span>}
        closeMenuOnSelect={options.length === 1}
        isSearchable={false}
        onChange={wrappedOnChange}
        classNamePrefix="multi-select"
        components={{ DropdownIndicator }}
        options={options}
      />
      {savable() ? (
        <div className="editable-value__control active">
          <LoaderButton onClick={onSave} buttonType="input-attached" isLoading={isSaving}>
            <Translate value={actionI18nKey} />
          </LoaderButton>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authorities: state.auth.authorities
  };
};

export default connect(mapStateToProps)(SaveableMultiSelect);
